import React, { useState, useEffect } from 'react';
import { jsx, css } from '@emotion/react';
import { connectLocation } from "../../location/LocationConnectors";
import wrappedInReduxProvider from "../../wrappedInReduxProvider";
import LocationSwitcher from '../../location/Switcher';

// Components
import Hero from '../../OC/oc-hero';
import UtilityBar from '../../ComponentLibrary/layout/oc-utility-bar';
import { Breadcrumbs, Breadcrumb } from '../../ComponentLibrary/oc-breadcrumbs';

import ContentHeader from './ContentHeader';
import Map from './Map';

import Container from '../../OC/oc-container';
import { ProfessionalResultBlock } from '../../ComponentLibrary/filter-result-blocks/oc-professional-result-block';
import FilterListResults from '../../ComponentLibrary/filter-list/oc-filter-list-results'
import HierarchicalFilter from '../../ComponentLibrary/filter-tree/oc-hierarchical-filter';
import CheckboxSelector from '../../ComponentLibrary/filter-list/oc-filters';
import DistanceSelector from '../../ComponentLibrary/oc-distance-selector';
import GroupInfoDropdown from '../../ComponentLibrary/oc-group-info-dropdown';
import {H5} from "../../OC/oc-h";

const ResultComponent = ({...props}) => {
  return(
    <>
      <ProfessionalResultBlock resource={props}/>
    </>
  )}

const Disclaimer = connectLocation(({ t }) => {
  return (
    <div className="footnote">
      <p><b>{t(`generic_locator.store_visit_disclaimer_title`)}</b></p>
      <p>{t(`generic_locator.store_visit_disclaimer`)}</p>
    </div>
  );
});

const webSiteFormatter = (website) => {
  const webSitePattern = new RegExp( /(http(s?)):\/\//);
  return webSitePattern.test(website)
    ? website
    : '//' + website
}

const DealerLocator = connectLocation(({ t, ...props })  => {
  const contentHeaderProps = { valid: props.address.valid, city: props.address.city, region: props.address.region };
  const perPageResults = props.per_page || 100
  const parseData = (result) => {
     return result.data.map(row => (
       {
        address: row.address,
        city: row.city,
        country: row.country,
        distance: row.distance,
        latitude: row.latitude,
        longitude: row.longitude,
        phone: row.phone,
        record_id: row.source_id,
        state: row.state,
        name: row.name,
        type: row.source,
        zip: row.postal,
        website_address: row.website ? webSiteFormatter(row.website) : null
       })
     )
  };

  const [lists, setLists] = useState([{ name: 'dealers', data: parseData(props.result) }]);

  const getObjQuery = (name, obj) => {
    let query = ``;
    Object.keys(obj).forEach( key => query+= `${name}[${key}]=${obj[key]}&`)
    return query;
  }

  const updateDistance = (radius) => {
    if (props.address.valid) {
      fetch(MDMS_URL + `/api/v2/locations/insulation/residential/dealer-locator?per_page=${perPageResults}&c_code=CA&radius=${radius}&${getObjQuery('address', props.address)}`)
        .then(response => response.json(), err => {})
        .then(result => setLists([{ name: 'dealers', data: parseData(result) }]))
    }
  }

  const filters = {
    distance: {
      component: DistanceSelector,
      displayName: 'Distance',
      options: [
        { displayName: '20', value: '20' },
        { displayName: '40', value: '40' },
        { displayName: '60', value: '60' }
      ],
      matchType: 'ajax',
      onChange: updateDistance
    },
    noOperation: {
      component: Disclaimer,
      options: [],
    }
  }

  return (
    <>
      <UtilityBar>
        <Breadcrumbs>
          <Breadcrumb href="/insulation" label={t("insulation.product.breadcrumbs.base")} />
          <Breadcrumb href="/insulation/residential" label={t("insulation.product.breadcrumbs.residential")} />
        </Breadcrumbs>
        <LocationSwitcher showLocale />
      </UtilityBar>

      <div css={css`
        & > div {
          @media (max-width: 1199px) {
            background-size: cover;
          }
        }`}>

        <Hero
          imgDesktop={ { file: "https://imagecdn.owenscorning.com/ocimages/image/upload/q_auto/v1637595134/insulation/residential/distributors-near-me/hero-desktop.jpg" } }
          imgTablet={ { file: "https://imagecdn.owenscorning.com/ocimages/image/upload/q_auto/v1637595134/insulation/residential/distributors-near-me/hero-desktop.jpg" } }
          prehead=""
          h1={t('generic_locator.insulation_dealer_hero_text')}
          posthead=""
        />
      </div>

      <Container maxWidth="1170">
        <FilterListResults
          contentHeader={{ component: ContentHeader, props: contentHeaderProps }}
          defaultDistance={20}
          filters={filters}
          lists={lists}
          primaryActiveDefault={true}
          resetDistance={updateDistance}
          resultComponent={ResultComponent}
          secondaryContent={Map}
        />
      </Container>
    </>
  )
});

export default wrappedInReduxProvider(connectLocation(DealerLocator));
